import React, { useState, useEffect } from 'react';
import Header from '../../Header';
import Banner from '../Banner';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../Footer';
import HeroImageTextSection from '../../TextSections/HeroImageTextSection';

const TABS = [
  { key: 'overview', tr: 'Genel Bakış', en: 'Overview', path: '' },
  { key: 'team', tr: 'Ekibimiz', en: 'Our Team', path: 'team' },
];

const content = {
  tr: {
    title: 'Ekibimiz',
    description: 'Deneyimli ekibimizle müşterilerimize en iyi hizmeti sunuyoruz',
    footerLang: 'tr',
    headerLang: 'tr',
  },
  en: {
    title: 'Our Team',
    description: 'We provide the best service to our customers with our experienced team',
    footerLang: 'en',
    headerLang: 'en',
  },
};

const teamMembers = [
  { name: 'Ecem Yılmazer Karaman', image: '/ecem-yilmazer.jpeg', roleTr: 'İdari İşler Personeli', roleEn: 'Administrative Affairs Officer', descTr: 'İdari işler ve operasyon süreçlerinde görev alıyor.', descEn: 'Works in administrative affairs and operational processes.' },
  { name: 'Abdulkadir Gönül', image: '/abdulkadir-gonul.jpeg', roleTr: 'Pazarlamacı', roleEn: 'Marketing Specialist', descTr: 'Pazarlama ve iletişim faaliyetlerimizi yürütüyor.', descEn: 'Runs our marketing and communication activities.' },
  { name: 'Aslı Harputlu', image: '/asli-harputlu.jpeg', roleTr: 'Pazarlamacı', roleEn: 'Marketing Specialist', descTr: 'Pazarlama ve iletişim faaliyetlerimizi yürütüyor.', descEn: 'Runs our marketing and communication activities.' },
  { name: 'Emine Uygun', image: '/emine-uygun.jpeg', roleTr: 'Yazılımcı', roleEn: 'Software Developer', descTr: 'Yazılım geliştirme ekibimizin bir üyesi.', descEn: 'A member of our software development team.' },
  { name: 'Mikail Ayan', image: '/mikail-ayan.jpeg', roleTr: 'Yazılımcı', roleEn: 'Software Developer', descTr: 'Yazılım geliştirme ekibimizin bir üyesi.', descEn: 'A member of our software development team.' },
  { name: 'Varis Atasoy', image: '/varis-atasoy.jpeg', roleTr: 'Yazılımcı', roleEn: 'Software Developer', descTr: 'Yazılım geliştirme ekibimizin bir üyesi.', descEn: 'A member of our software development team.' },
  { name: 'Ataberk Alkan', image: '/ataberk-alkan.jpeg', roleTr: 'Yazılımcı', roleEn: 'Software Developer', descTr: 'Yazılım geliştirme ekibimizin bir üyesi.', descEn: 'A member of our software development team.' },
];

const Team: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const language = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const lang: 'en' | 'tr' = language;
  const page = content[lang];

  // URL'den aktif sekmeyi belirle
  const pathParts = location.pathname.split('/');
  const tabPath = pathParts[pathParts.length - 1];
  const initialTab = tabPath === 'team' && pathParts.length > 4 ? 'team' : 'overview';
  const [selectedTab, setSelectedTab] = useState(initialTab);

  // Sekme değişince URL'yi güncelle
  const handleTabChange = (key: string) => {
    setSelectedTab(key);
    const tabObj = TABS.find(t => t.key === key);
    let base = `/${lang}/about/team`;
    if (tabObj && tabObj.path && tabObj.path !== '') base += `/${tabObj.path}`;
    navigate(base, { replace: true });
  };

  // URL değişirse sekmeyi güncelle
  useEffect(() => {
    const parts = location.pathname.split('/');
    const last = parts[parts.length - 1];
    setSelectedTab(last === 'team' && parts.length > 4 ? 'team' : 'overview');
  }, [location.pathname]);

  // Breadcrumb'u dinamik oluştur
  const breadcrumb = (
    <div className="mt-1 mb-2 text-sm flex items-center space-x-2">
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/team`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ekibimiz' : 'Our Team'}</Link>
    </div>
  );

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    navigate(newPath + location.search, { replace: true });
  };

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={page.title}
        description={page.description}
        image={process.env.PUBLIC_URL + '/banner.png'}
        breadcrumb={breadcrumb}
        tabs={TABS.map(tab => ({ key: tab.key, label: lang === 'tr' ? tab.tr : tab.en }))}
        selectedTab={selectedTab}
        onTabChange={handleTabChange}
      />
      {/* Genel Bakış sekmesi seçiliyse özel section'lar */}
      {selectedTab === 'overview' && (
        <>
          <HeroImageTextSection
            title={lang === 'tr' ? 'Ekibimiz' : 'Our Team'}
            style={{ textAlign: 'justify' }}
            paragraphs={[
              lang === 'tr'
                ? 'CG Teknoloji A.Ş., yalnızca geliştirdiği yenilikçi teknolojilerle değil; aynı zamanda alanında uzman, vizyon sahibi ve tutkulu ekibiyle de fark yaratmaktadır.'
                : 'CG Technology Inc. makes a difference not only with the innovative technologies it develops; but also with its expert, visionary and passionate team.',
              lang === 'tr'
                ? 'Her biri kendi uzmanlık alanında derin bilgi ve deneyime sahip kadromuz, yapay zeka destekli çözümler geliştirerek işletmelere katma değer sağlamak amacıyla çalışır.'
                : 'Our staff, each with deep knowledge and experience in their own field of expertise, works to provide added value to businesses by developing AI-powered solutions.',
              lang === 'tr'
                ? 'Biz teknolojinin arkasında insanın gücünün olduğuna inanıyoruz. Bu nedenle ekip kültürümüzü güven, iş birliği ve sürekli gelişim ilkeleri üzerine inşa ediyoruz.'
                : 'We believe in the power of people behind technology. That\'s why we build our team culture on the principles of trust, collaboration and continuous improvement.',
              lang === 'tr'
                ? 'Takım çalışması, öğrenme ve inovasyon kültürümüz sayesinde her projede mükemmelliği hedefliyoruz. Uzmanlık alanlarımız; yapay zeka, makine öğrenimi, web geliştirme, mobil teknolojiler ve daha fazlasını kapsayan geniş bir yelpazeye yayılmış durumdadır.'
                : 'Thanks to our culture of teamwork, learning and innovation, we aim for excellence in every project. Our areas of expertise are spread across a wide range covering artificial intelligence, machine learning, web development, mobile technologies and more.'
            ]}
          />
        </>
      )}
      {/* Ekibimiz sekmesi seçiliyse özel section'lar */}
      {selectedTab === 'team' && (
        <>
          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4">
              <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
                {lang === 'tr' ? 'Ekibimiz' : 'Our Team'}
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {teamMembers.map((member) => (
                  <div key={member.name} className="bg-white rounded-xl shadow-lg p-6 text-center transition-all duration-300 hover:shadow-xl hover:scale-105">
                    <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden bg-gray-200">
                      <img
                        src={process.env.PUBLIC_URL + member.image}
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <h3 className="text-lg font-bold mb-2 text-gray-900">{member.name}</h3>
                    <p className="text-red-600 font-semibold mb-3">{lang === 'tr' ? member.roleTr : member.roleEn}</p>
                    <p className="text-sm text-gray-600 leading-relaxed">{lang === 'tr' ? member.descTr : member.descEn}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </>
      )}
      <Footer language={lang} />
    </div>
  );
};

export default Team;
